import React from "react";
import { delay, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
    containerVariants,
    itemVariants,
    photoVariants,
} from "../../variants/variants";

const Section1 = () => {
  const { t } = useTranslation();
  
  return (
    <motion.div
      className="mt-14"
      initial="hidden"
      whileInView="visible"
      exit="exit"
      variants={containerVariants}
    >
      <motion.h1 variants={itemVariants} className="text-65 text-customBlack mb-5">
        {t("sustainability.manifesto.title")}
      </motion.h1>
      <motion.p variants={itemVariants} className="text-20 font-medium text-customGray5">
        {t("sustainability.manifesto.text1")}
      </motion.p>
      <motion.p variants={itemVariants} className="text-20 font-medium text-customGray5 mb-5">
        {t("sustainability.manifesto.text2")}
      </motion.p>
      <motion.p variants={itemVariants} className="text-20 font-medium text-customGray5">
        {t("sustainability.manifesto.text3")}
      </motion.p>
    </motion.div>
  );
};

export default Section1;
